/**
 * Sincroniza optima-quantity-pricing (1/2/3) con ofertas EasySell en el popup.
 * EasySell bloquea ES_SELECT_OFFER_BY_QUANTITY si la oferta "1 Unit" tiene preselected:true
 * → forzamos selección por clic en filas visibles del modal y parcheamos la API.
 */
(function () {
  const CART_ROOT = `${window.Shopify?.routes?.root || '/'}`;

  function formatOrderMoney(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'string' && /[A-Za-z$₡]/.test(value)) return value;
    const amount = Number.parseFloat(value);
    if (!Number.isFinite(amount)) return String(value);
    try {
      return new Intl.NumberFormat('es-NI', { style: 'currency', currency: 'NIO' }).format(amount);
    } catch {
      return `C$${amount.toFixed(2)}`;
    }
  }

  function getCustomerName(order) {
    const ship = order?.shipping_address || order?.shippingAddress || {};
    const bill = order?.billing_address || order?.billingAddress || {};
    const cust = order?.customer || {};
    let name = [ship.first_name || ship.firstName, ship.last_name || ship.lastName]
      .filter(Boolean)
      .join(' ')
      .trim();
    if (!name) {
      name = [bill.first_name || bill.firstName, bill.last_name || bill.lastName]
        .filter(Boolean)
        .join(' ')
        .trim();
    }
    if (!name) {
      name = [cust.first_name || cust.firstName, cust.last_name || cust.lastName]
        .filter(Boolean)
        .join(' ')
        .trim();
    }
    if (!name && ship.name) name = String(ship.name).trim();
    if (!name && order?.first_name) name = String(order.first_name).trim();
    if (!name && order?.fullname) name = String(order.fullname).trim();

    const notes = order?.note_attributes || order?.noteAttributes || [];
    if (!name && Array.isArray(notes)) {
      for (const entry of notes) {
        const key = String(entry?.name || entry?.key || '').toLowerCase();
        if (key.includes('nombre') || key === 'name' || key.includes('first_name')) {
          const value = entry?.value;
          if (value) {
            name = String(value).trim();
            break;
          }
        }
      }
    }

    return name;
  }

  function getLineImage(item) {
    if (typeof item?.image === 'string' && item.image) return item.image;
    if (item?.image?.src) return item.image.src;
    if (item?.image?.url) return item.image.url;
    if (item?.featured_image?.url) return item.featured_image.url;
    if (typeof item?.thumbnail === 'string') return item.thumbnail;
    return '';
  }

  function summarizeEasySellOrder(order) {
    const items = Array.isArray(order?.line_items)
      ? order.line_items
      : Array.isArray(order?.items)
        ? order.items
        : [];
    const normalized = items
      .map((item) => {
        const qty = Number(item?.quantity) || 1;
        const title = item?.name || item?.title || item?.product_title || '';
        if (!title) return null;
        return {
          qty,
          title,
          image: getLineImage(item),
        };
      })
      .filter(Boolean);
    const lines = normalized.map((item) => `${item.qty} × ${item.title}`);
    const customerName = getCustomerName(order);
    const customer = order?.customer || {};
    const orderNumber = order?.order_number || order?.number || '';
    const orderName = order?.name || (orderNumber ? `#${orderNumber}` : '');

    return {
      name: orderName,
      number: orderNumber,
      firstName: customer.first_name || customer.firstName || customerName.split(/\s+/)[0] || '',
      customerName,
      total: formatOrderMoney(order?.total_price ?? order?.current_total_price ?? ''),
      lines,
      items: normalized,
    };
  }

  function captureFormCustomerName() {
    const named = document.querySelector(
      '#easysell input[name="first_name"], #easysell-modal input[name="first_name"], #easysell input[name="nombre"]',
    );
    if (named instanceof HTMLInputElement && named.value.trim()) return named.value.trim();

    const fields = document.querySelectorAll('#easysell input, #easysell-modal input, #easysell textarea');
    for (const field of fields) {
      if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) continue;
      const value = field.value?.trim();
      if (!value) continue;
      const label =
        field.closest('.es-field, .form-group, .es-input-group')?.querySelector('label')?.textContent || '';
      if (/nombre/i.test(label) || /nombre/i.test(field.placeholder || '')) return value;
    }
    return '';
  }

  function installEasySellThankYouRedirect() {
    if (window.es_hook_before_redirect?.__optima) return;

    const redirect = async (order) => {
      const summary = summarizeEasySellOrder(order);
      if (!summary.customerName) {
        const fromForm = captureFormCustomerName();
        if (fromForm) summary.customerName = fromForm;
      }

      try {
        sessionStorage.setItem('optima.thankyou.gate', String(Date.now()));
        sessionStorage.setItem('optima.thankyou', JSON.stringify(summary));
      } catch {
        /* ignore */
      }

      const path = `${CART_ROOT}pages/gracias`.replace(/([^:]\/)\/+/g, '$1');
      window.location.replace(path);
      await new Promise(() => {});
    };

    redirect.__optima = true;
    window.es_hook_before_redirect = redirect;
  }

  installEasySellThankYouRedirect();

  /** @type {{ qty: number, timerId: number } | null} */
  let activeSync = null;

  /** @returns {1 | 2 | 3} */
  function getSelectedQuantity() {
    const tier =
      document.querySelector(
        '.product-information optima-quantity-pricing [data-optima-qty].is-selected',
      ) ||
      document.querySelector('.product-details optima-quantity-pricing [data-optima-qty].is-selected');

    if (tier) {
      const qty = Number.parseInt(tier.getAttribute('data-optima-qty') || '1', 10);
      if (qty === 1 || qty === 2 || qty === 3) return qty;
    }

    const picker = document.querySelector('[name="es-quantity-picker"][data-optima-es-qty]');
    if (picker instanceof HTMLInputElement) {
      const qty = Number.parseInt(picker.value || '1', 10);
      if (qty === 1 || qty === 2 || qty === 3) return qty;
    }

    const input =
      document.querySelector('.product-information input[name="quantity"]') ||
      document.querySelector('.product-details input[name="quantity"]');
    if (input instanceof HTMLInputElement) {
      const qty = Number.parseInt(input.value || '1', 10);
      if (qty === 1 || qty === 2 || qty === 3) return qty;
    }

    return 1;
  }

  function getProductAddForm() {
    return document.querySelector(
      '.product-information form[data-type="add-to-cart-form"], .product-details form[data-type="add-to-cart-form"]',
    );
  }

  function ensureEasySellQuantityPicker() {
    let picker = document.querySelector('[name="es-quantity-picker"][data-optima-es-qty]');
    if (!(picker instanceof HTMLInputElement)) {
      picker = document.createElement('input');
      picker.type = 'hidden';
      picker.name = 'es-quantity-picker';
      picker.dataset.optimaEsQty = 'true';
      const form = getProductAddForm();
      if (form) form.appendChild(picker);
      else document.body.appendChild(picker);
    }
    return picker;
  }

  /** @param {1 | 2 | 3} qty */
  function syncShopifyQuantityInputs(qty) {
    ensureEasySellQuantityPicker().value = String(qty);

    const inputs = document.querySelectorAll(
      '.product-information input[name="quantity"], .product-details input[name="quantity"]',
    );
    inputs.forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      input.value = String(qty);
    });

    document.documentElement.dataset.optimaEasySellQty = String(qty);
    try {
      sessionStorage.setItem('optima.easysell.qty', String(qty));
    } catch {
      /* ignore */
    }
  }

  function bindEasySellFormContext() {
    const form = getProductAddForm();
    if (form instanceof HTMLFormElement) {
      window.ES_CLOSEST_FORM = form;
    }
  }

  function isEasySellPopupOpen() {
    const modal = document.getElementById('easysell-modal');
    if (!(modal instanceof HTMLElement)) return false;
    return window.getComputedStyle(modal).display !== 'none';
  }

  function findOfferRows() {
    if (!isEasySellPopupOpen()) return [];

    const container =
      document.querySelector('#easysell-modal #easysell') ||
      document.querySelector('#easysell-modal .es-modal-content') ||
      document.getElementById('easysell-modal');

    if (!(container instanceof HTMLElement)) return [];

    /** @type {HTMLElement[]} */
    const rows = [];
    container
      .querySelectorAll('.es-b-standard-row, .es-b-card.es-b-card--vertical, .es-b-card')
      .forEach((row) => {
        if (row instanceof HTMLElement) rows.push(row);
      });

    return rows;
  }

  /** @param {HTMLElement[]} rows @param {1 | 2 | 3} qty */
  function pickRowForQuantity(rows, qty) {
    if (rows[qty - 1] instanceof HTMLElement) return rows[qty - 1];

    const patterns =
      qty === 1
        ? [/\b1\s*unit/i, /1\s*unidad/i]
        : qty === 2
          ? [/\b2\s*unit/i, /2\s*unidad/i]
          : [/\b3\s*unit/i, /3\s*unidad/i];

    for (const row of rows) {
      const text = row.textContent || '';
      if (patterns.some((re) => re.test(text))) return row;
    }

    return null;
  }

  /** @param {1 | 2 | 3} qty */
  function isEasySellQuantityActive(qty) {
    const rows = findOfferRows();
    const row = pickRowForQuantity(rows, qty);
    if (!(row instanceof HTMLElement)) return false;
    return row.getAttribute('offer-selected') === 'true';
  }

  /** @param {1 | 2 | 3} qty */
  function forceSelectEasySellQuantity(qty) {
    if (isEasySellQuantityActive(qty)) return true;

    const rows = findOfferRows();
    const target = pickRowForQuantity(rows, qty);
    if (!(target instanceof HTMLElement)) return false;

    target.click();
    return isEasySellQuantityActive(qty);
  }

  function patchEasySellQuantityApi() {
    const native = window.ES_SELECT_OFFER_BY_QUANTITY;
    if (typeof native !== 'function' || native.__optimaPatched) return;

    window.ES_SELECT_OFFER_BY_QUANTITY = function patchedSelectByQuantity(qty) {
      const parsed = Number.parseInt(String(qty), 10);
      if (parsed === 1 || parsed === 2 || parsed === 3) {
        forceSelectEasySellQuantity(parsed);
      }
      try {
        native.call(this, qty);
      } catch {
        /* ignore */
      }
    };
    window.ES_SELECT_OFFER_BY_QUANTITY.__optimaPatched = true;
  }

  function waitForEasySellApi() {
    if (window.ES_SELECT_OFFER_BY_QUANTITY) {
      patchEasySellQuantityApi();
      return;
    }
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (window.ES_SELECT_OFFER_BY_QUANTITY || attempts > 80) {
        window.clearInterval(timer);
        patchEasySellQuantityApi();
      }
    }, 100);
  }

  function cancelActiveSync() {
    if (activeSync) {
      window.clearTimeout(activeSync.timerId);
      activeSync = null;
    }
  }

  /** @param {1 | 2 | 3} qty */
  function scheduleEasySellQuantitySync(qty) {
    cancelActiveSync();

    const delays = [0, 80, 160, 280, 420, 600, 850, 1100, 1400, 1800, 2300];
    let step = 0;

    const run = () => {
      if (!activeSync || activeSync.qty !== qty) return;

      if (forceSelectEasySellQuantity(qty) || step >= delays.length - 1) {
        cancelActiveSync();
        return;
      }

      step += 1;
      activeSync.timerId = window.setTimeout(run, delays[step]);
    };

    activeSync = { qty, timerId: window.setTimeout(run, delays[0]) };
  }

  function isEasySellTrigger(target) {
    if (!(target instanceof Element)) return null;
    if (target.closest('#easysell-modal, .es-b-standard-row, .es-b-card')) return null;
    return target.closest(
      '.product-information .es-popup-button, .product-information .es-popup-button-overwrite, .product-information [data-optima-open-easysell], .product-details .es-popup-button, .product-details .es-popup-button-overwrite, .product-details [data-optima-open-easysell]',
    );
  }

  function isNativeAddToCart(target) {
    if (!(target instanceof Element)) return false;
    if (target.closest('.es-popup-button, .es-popup-button-overwrite')) return false;
    return Boolean(target.closest('button[name="add"], .add-to-cart-button, [data-testid="standalone-add-to-cart"]'));
  }

  function handleEasySellOpen(event) {
    const trigger = isEasySellTrigger(event.target);
    if (!trigger) return;

    const qty = getSelectedQuantity();
    bindEasySellFormContext();
    syncShopifyQuantityInputs(qty);
    scheduleEasySellQuantitySync(qty);
  }

  function blockNativeCartAdds(event) {
    if (!document.body.classList.contains('optima-theme')) return;
    if (!isNativeAddToCart(event.target)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const easySell =
      document.querySelector('.product-information .product-form-buttons .es-popup-button') ||
      document.querySelector('.product-details .product-form-buttons .es-popup-button');
    if (easySell instanceof HTMLElement) easySell.click();
  }

  function initEasySellQuantityHooks() {
    if (!document.querySelector('.product-information, .product-details')) return;

    window.ES_QUANTITY_SELECTOR_OVERRIDE =
      '.product-information input[name="quantity"], .product-details input[name="quantity"]';

    bindEasySellFormContext();
    syncShopifyQuantityInputs(getSelectedQuantity());
    waitForEasySellApi();
  }

  document.addEventListener('click', handleEasySellOpen, true);
  document.addEventListener('click', blockNativeCartAdds, true);

  document.addEventListener(
    'optima:quantity-tier-selected',
    (event) => {
      const detail = event instanceof CustomEvent ? event.detail : null;
      const qty = detail?.quantity;
      if (qty !== 1 && qty !== 2 && qty !== 3) return;

      syncShopifyQuantityInputs(qty);
      if (isEasySellPopupOpen()) scheduleEasySellQuantitySync(qty);
    },
    false,
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEasySellQuantityHooks, { once: true });
  } else {
    initEasySellQuantityHooks();
  }

  document.addEventListener('shopify:section:load', initEasySellQuantityHooks);
})();
